import * as React from "react";
import classnames from "classnames";
import { useDrawer } from "@grandvisionhq/common";
import { PrescriptionInformationLink } from "../../../../../../PrescriptionInformationLink/steps/components/PrescriptionInformationLink/PrescriptionInformationLink.js";
/* empty css                                          */
const PrescriptionInformationDrawerTrigger = ({
  children,
  className,
  onClick
}) => {
  const { toggle } = useDrawer();
  const handleClick = () => {
    onClick();
    toggle();
  };
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: classnames("prescription-information-drawer-trigger", className),
      "data-t": "prescription-form-drawer-trigger",
      onClick: handleClick,
      type: "button"
    },
    /* @__PURE__ */ React.createElement(PrescriptionInformationLink, null, children)
  );
};
export {
  PrescriptionInformationDrawerTrigger
};
//# sourceMappingURL=PrescriptionInformationDrawerTrigger.js.map
